module.exports = __webpack_public_path__ + "static/media/logo.c487648d.svg";